import { motion } from "framer-motion";
import { Star } from "lucide-react";
import { TrustindexReviews } from "@/components/site/TrustindexReviews";

/**
 * ReviewsSection
 * --------------
 * Consistent, themed wrapper that hosts the Trustindex reviews widget on
 * the homepage, contact page and service pages. Uses the same section
 * padding / kicker / display heading rhythm as the rest of the site so it
 * doesn't look grafted on.
 */
export const ReviewsSection = ({
  kicker = "Client reviews",
  title = "What people say about working with us.",
  subtitle = "Real reviews from real clients across South Africa and beyond, pulled live from Google.",
  className = "",
}) => {
  return (
    <section
      data-testid="reviews-section"
      className={`section-pad bg-[hsl(225,22%,4%)] ${className}`}
    >
      <div className="container-site">
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-40px" }}
          transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
          className="max-w-3xl mb-10 sm:mb-14"
        >
          <p className="kicker mb-3 inline-flex items-center gap-2">
            <Star className="h-3.5 w-3.5 fill-current text-[hsl(var(--primary))]" />
            {kicker}
          </p>
          <h2 className="font-display uppercase text-foreground text-[clamp(2rem,5vw,4rem)] leading-[0.95] tracking-[-0.005em]">
            {title}
          </h2>
          {subtitle && (
            <p className="mt-5 text-sm sm:text-base text-muted-foreground max-w-2xl leading-relaxed">
              {subtitle}
            </p>
          )}
        </motion.div>
        <TrustindexReviews className="min-h-[240px]" />
      </div>
    </section>
  );
};

export default ReviewsSection;
